var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoneBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.761,
    height: 15.738,
    viewBox: "0 0 15.761 15.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_phone_2236799_000000",
    d: "M24.109,25.43l1.537-1.537a1.211,1.211,0,0,0-.178-1.3c-.473-.532-2.6-2.542-2.6-2.542s-.591-.414-1.359.354l-.71.768a.777.777,0,0,1-.827.059,15.3,15.3,0,0,1-5.438-5.379.848.848,0,0,1,.118-.886l.71-.71c.827-.768.414-1.359.414-1.359s-2.01-2.069-2.6-2.6a1.148,1.148,0,0,0-1.3-.118l-1.537,1.478C7.914,16.563,19.2,27.851,24.108,25.428Z",
    transform: "translate(-10.001 -10.026)",
    fill: "#0f5562",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneBlue);
export default __webpack_public_path__ + "static/media/icon-phone-blue.50bf8b023554f049198774eaddba460e.svg";
export { ForwardRef as ReactComponent };